import React from "react";
import { Link } from "react-router-dom";

import "./terms_page.css";

import Logo from "../assets/composiq-mark-128.png";

const TERMLY_POLICY_ID = "21df575f-0a0b-4736-9680-6336497df3f0";
const TERMLY_SCRIPT_SRC = "https://app.termly.io/embed-policy.min.js";

export default function TermsPage(){
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [termlyReady, setTermlyReady] = React.useState(false);
  const embedRef = React.useRef(null);

  React.useEffect(() => {
    let cancelled = false;

    // Remove any previous Termly embed script so it re-scans on SPA nav
    const oldScripts = document.querySelectorAll('script[src*="embed-policy"]');
    oldScripts.forEach((s) => s.remove());

    // Insert a fresh script tag so Termly re-scans the DOM
    const js = document.createElement("script");
    js.src = TERMLY_SCRIPT_SRC;
    js.async = true;
    js.onload = () => {
      let attempts = 0;
      const poll = setInterval(() => {
        attempts++;
        if (cancelled) { clearInterval(poll); return; }
        const el = embedRef.current;
        if (el && el.children.length > 0) {
          setTermlyReady(true);
          clearInterval(poll);
        }
        if (attempts > 50) {
          setTermlyReady(true);
          clearInterval(poll);
        }
      }, 200);
    };
    document.body.appendChild(js);

    return () => { cancelled = true; };
  }, []);

  const termlyHasContent = embedRef.current && embedRef.current.children.length > 0;

  return (
    <div className="App">
      {/* ───────── HEADER (match Home) ───────── */}
      <header className="dbx-header" role="banner">
        <div className="dbx-header-inner">
          <Link to="/" className="dbx-brand" aria-label="Zerivo home">
            <img className="dbx-brand-mark" src={Logo} alt="" />
            <div className="dbx-brand-text-group">
              <span className="dbx-brand-text">Zerivo</span>
              <span className="dbx-brand-subtitle">Private AI</span>
            </div>
          </Link>

          <nav className="dbx-header-nav" aria-label="Main navigation">
            <Link to="/our-team">Our Team</Link>
            <Link to="/contact">Contact</Link>
          </nav>

        </div>
      </header>

      {mobileOpen && (
        <nav className="dbx-mobile-nav" role="navigation" aria-label="Mobile navigation">
          <button className="dbx-mobile-close" onClick={() => setMobileOpen(false)} aria-label="Close menu">×</button>
          <Link to="/our-team" onClick={() => setMobileOpen(false)}>Our Team</Link>
          <Link to="/contact" onClick={() => setMobileOpen(false)}>Contact</Link>
          <Link to="/privacy" onClick={() => setMobileOpen(false)}>Privacy</Link>
          <Link to="/terms" onClick={() => setMobileOpen(false)}>Terms</Link>
        </nav>
      )}
      {mobileOpen && <div className="dbx-mobile-backdrop" onClick={() => setMobileOpen(false)} aria-hidden="true"></div>}

      {/* ───────── MAIN CONTENT ───────── */}
      <main className="terms-wrapper">
        <h1 className="terms-title">Terms of Service</h1>
        <p className="terms-intro">
          These terms govern your use of our website and services.
        </p>

        {/* Loading indicator while Termly loads */}
        {!termlyReady && (
          <div className="terms-loading" aria-live="polite">
            <span className="terms-spinner" aria-hidden="true" />
            Loading terms…
          </div>
        )}

        {/* Termly Embed */}
        <div ref={embedRef} name="termly-embed" data-id={TERMLY_POLICY_ID}></div>

        {/* Fallback — only if Termly timed out without populating */}
        {termlyReady && !termlyHasContent && (
          <div className="terms-fallback">
            <section className="terms-section">
              <h2>About These Terms</h2>
              <p>
                These Terms govern your use of our website and services. For the most current version,
                please refer to the policy rendered above.
              </p>
            </section>
          </div>
        )}
      </main>
    </div>
  );
}
